import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useLogoutApi } from '@hero/api-hooks';
import { useNav } from '../navigation/useNav';
import { resetSessionCache } from './resetSessionCache';
import { clearAuthTokens } from './tokens';

export const useLogoutManager = () => {
  const { mutateAsync } = useLogoutApi();
  const queryClient = useQueryClient();
  const { navigate } = useNav();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useCallback(async () => {
    setIsLoggingOut(true);
    try {
      await mutateAsync(undefined as any);
    } catch {
      // Always clean up regardless of API failure
    } finally {
      clearAuthTokens();
      navigate('auth_register');
      resetSessionCache(queryClient, 'sign-out');
      setIsLoggingOut(false);
    }
  }, [mutateAsync, queryClient, navigate]);

  return { logout, isLoggingOut };
};
